import React, { useState,useEffect } from 'react';
import DatePicker from "react-datepicker";
import csvDownload from 'json-to-csv-export';
import moment from 'moment';
import './styles.css';
import "react-datepicker/dist/react-datepicker.css";
export default function App() {
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  let [role, setRole] = useState('');  
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const logo='https://raw.githubusercontent.com/kgetechnologies/kgesitecdn/refs/heads/donationapp/donation/Logo.jpg';
  const paymentMode = [
    { key: 'Bank', value: 'Bank', type: '' },
    { key: 'Cash', value: 'Cash', type: '' },
    { key: 'Cheque', value: 'Cheque', type: 'Input' },
    {
      key: 'UPI',
      value:
        'https://raw.githubusercontent.com/kgetechnologies/kgesitecdn/refs/heads/donationapp/donation/qrcode/UPIQRCode.png',
      type: 'Image',
    },
  ];
  
  //Object Id/Name/Status/DeactivatedOn/AddedOn  
  const [ForPurpose, setselectedForPurpose]= useState([]);
  const [selectedPurpose, setselectedPurpose] = useState();  
  const [ForPurposeAdmin, setselectedForPurposeAdmin]= useState([]);
  const [selectedPurposeAdmin, setselectedPurposeAdmin] = useState();  
  useEffect(() => {

    fetch("https://donationapi.kgetechnologies.com/api/donation/GetAllPurposeFor")
        .then(response => response.json())
        .then(json => {          
          setselectedForPurpose(json);
          setselectedForPurposeAdmin(json);
          setselectedPurpose(json[0].value); 
          setselectedPurposeAdmin(json[0].value);       
        });
}, []); 
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [mobile, setMobile] = useState('');
  const [location, setLocation] = useState('');
  const [amount, setAmount] = useState('');
  const [selectedMode, setselectedMode] = useState(paymentMode[0].key);
  const [chequeNumber, setchequeNumber] = useState(''); 
  const handleSubmit = (e) => {
    e.preventDefault();
  var data=  {
    "Name":name,
    "Email":email,
     "Mobile": mobile,
    "ChequeNumber":chequeNumber,
     "PaymentMode": selectedMode,
     "Amount": amount,
     "ForPurpose": selectedPurpose,
     "Location":location
  };
      fetch("https://donationapi.kgetechnologies.com/api/donation/createdata",{
        method: "POST",
        headers: {'Content-type':'application/json'},
        body: JSON.stringify(data)})
          .then(response => response.json())
          .then(json => {                    
          alert(json.data);
          handleReset();          
          });  
  };
  const handleAdminSubmit = (e) => {
    e.preventDefault();  
  var startDateFormat=moment(startDate).format("yyyy-MM-DD");
  var endDateFormat=moment(endDate).format("yyyy-MM-DD");
  var url="https://donationapi.kgetechnologies.com/api/donation/GetAllReportByFilter?PurposeType="+selectedPurposeAdmin+"&startDate="+startDateFormat+"&endDate="+endDateFormat;
      fetch(url,{
        method: "GET",
        headers: {'Content-type':'application/json'}})
          .then(response => response.json())
          .then(json => {                    
          console.log(json);
           // alert(json);            

            csvDownload({ data:json, filename:selectedPurposeAdmin+'_'+startDateFormat+'_'+endDateFormat, delimiter:'|', headers:['name','email','mobile','amount','paymentMode','forPurpose','chequeNumber','createdDate'] });
          //handleReset();          
        });  
  };


  const handleModeChange = (Obj) => {
    setselectedMode(Obj.key);
    setchequeNumber('');
  };
  const handleReset = () => {
    // Reset all state variables here
    setName('');
    setEmail('');
    setMobile('');
    setAmount('');
    setLocation('');
    setselectedMode(paymentMode[0].key);
    setselectedPurpose(ForPurpose[0].value);
    setchequeNumber('');    
  };

  const handleLoginSubmit = (event) => {
    event.preventDefault();

    if (!password) {
      setError('Please enter the password.');
      return;
    }  
if( password=='form' || password=='admin'){
  role=password; 
  setRole(password);
  setError('');  
  return; 
}
else{
  setError('Please enter Correct password.');
  setPassword('');       
    setRole('');
}
  };

  return (
    <div className="App">
{role =='' &&
  <form onSubmit={handleLoginSubmit}>
      {error && <p style={{ color: 'red' }}>{error}</p>}    
      <div>
        <label htmlFor="password">Password:</label>
        <input
          type="password"
          id="password"
          value={password}
          onChange={(e)=> setPassword(e.target.value)}
        />
      </div>
      <button type="submit">Login</button>
    </form>
}
    {role === 'form' &&
    <div>
   <h1>Shri Selliyamman Alayam<img
              width="50" alt="logo"  style={{float: 'right'}}
              src={logo}
            /></h1> 
      <fieldset>
        <form action="#" method="get">
          <label>Name*</label>
          <input
            type="text"
            name="name"
            id="name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="Enter Name"
            required
          />
          <label>Email</label>
          <input
            type="email"
            name="email"
            id="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Enter Email"
          />
          <label>Mobile</label>
          <input
            type="tel"
            name="mobile"
            id="mobile"
            value={mobile}
            onChange={(e) => setMobile(e.target.value)}
            placeholder="Enter Mobile Number"
          />
           <label>Location*</label>
          <input
            type="location"
            name="location"
            id="location"
            onChange={(e) => setLocation(e.target.value)}
            placeholder="Enter Location Name"
            required
          />
          <label>Amount*</label>
          <input
            type="amount"
            name="amount"
            id="amount"
            onChange={(e) => setAmount(e.target.value)}
            placeholder="Enter Amount"
            required
          />

          <label>Mode of Payment</label>
          <select
            name="select"
            id="select"
            value={selectedMode}
            onChange={(e) => {
              var currentMode = paymentMode.find(
                (f) => f.key === e.target.value
              );
              handleModeChange(currentMode);
            }}
          >
            {/* <option value="" disabled selected={selectedMode === ''}>
              Select Mode of Payment
            </option> */}
            {paymentMode.map((val,key) => {
              return <option value={val.key} key={key}>{val.key} </option>;
            })}
          </select>
          {selectedMode === 'Cheque' && (
            <input
              type="text"
              name="chequeNumber"
              id="chequeNumber"
              value={chequeNumber}
              onChange={(e) => setchequeNumber(e.target.value)}
              placeholder="Enter Cheque Number"
            />
          )}
          {selectedMode === 'UPI' && (
            <img
              width="150" alt="upi code"
              src={paymentMode.find((f) => f.key === 'UPI').value}
            />
          )}
          <label>Purpose For</label>
          <select
            name="select"
            id="select"
            value={selectedPurpose}
            onChange={(e) => setselectedPurpose(e.target.value)}
          >
            {/* <option value="" disabled selected={selectedPurpose === ''}>
              Select Purpose For
            </option> */}
            {ForPurpose.map((val,key) => {
              return <option  key={key} value={val.key}>{val.key}</option>;
            })}
          </select>
         
          <button type="reset" value="reset" onClick={() => handleReset()}>
            Reset
          </button>
          <button type="submit" value="Submit" onClick={(e) => handleSubmit(e)}>
            Submit
          </button>
        </form>
      </fieldset>
      </div>
}
{role === 'admin' &&
      <div>
          <h1>Shri Selliyamman Alayam<img
              width="50" alt="logo"  style={{float: 'right'}}
              src={logo}
            /></h1> 
            
<fieldset>
        <form action="#" method="get">
          <label>Start Date</label>
          <DatePicker   name="startDate"
            id="startDate" selected={startDate} dateFormat="dd-MMM-yyyy" onChange={(date) => setStartDate(date)} />
        
          <label>End Date</label>
          <DatePicker   name="endDate"
            id="endDate" selected={endDate}  dateFormat="dd-MMM-yyyy" onChange={(date) => setEndDate(date)} />

          <label>Purpose Type</label>
          <select
            name="select"
            id="select"
            value={selectedPurposeAdmin}
            onChange={(e) => setselectedPurposeAdmin(e.target.value)}
          >
            {/* <option value="" disabled selected={selectedPurpose === ''}>
              Select Purpose For
            </option> */}
            {ForPurposeAdmin.map((val,key) => {
              return <option  key={key} value={val.key}>{val.key}</option>;
            })}
          </select>         
        
          <button type="submit" value="Submit" onClick={(e) => handleAdminSubmit(e)}>
            Submit
          </button>
        </form>
      </fieldset>
      {/* <h1> Filled Data</h1>
      <table>
        <tbody>
        <tr>
          <th>Name</th>                   
          <th>Mobile Number</th>
          <th>Amount</th>
          <th>Payment Mode</th>
        </tr>
        {data.map((val, i) => {     
           return ( <tr key={i}>
            <td>{val.name}</td>                          
            <td>{val.mobile}</td>
            <td>{val.amount}</td>
            <td>{val.paymentMode}</td>          
          </tr>) 
        })}       
        </tbody>
      </table>*/}
      </div> 
}
    </div>
  );
}